// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"643":"84c11ba1","659":"8fb62896"}[chunkId] + ".css";
};